// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__28g0I","footer":"ModalInfo_footer__2mKVN"};